// extracted by mini-css-extract-plugin
export default {"ani":"Ani_ani__pt-w8","animateBg":"Ani_animateBg__mdBj2","shoot":"Ani_shoot__7s+7H","animate":"Ani_animate__RmnoS"};